import React from 'react';
import styles from './StateIcon.module.scss';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import {ReactComponent as EmptyCircle} from 'assets/img/emptyCircle.svg';
import {ReactComponent as CircleInCircle} from 'assets/img/circleInCircle.svg';

interface IStateIconProps {
  step?: number;
  activeStep?: number;
}


const StateIcon = (props: IStateIconProps) => {

  if (props.activeStep > props.step) {
    return (<CheckCircleRoundedIcon className={`${styles.StateIcon} ${styles.complete}`}/>);
  } else if (props.activeStep === props.step) {
    return (<CircleInCircle className={`${styles.StateIcon} ${styles.current}`}/>);
  } else {
    return (<EmptyCircle className={`${styles.StateIcon} ${styles.inactive}`}/>);
  }

};

StateIcon.defaultProps = {};

export default React.memo(StateIcon);
